
export const BASEURLS = (path) => {
    return `https://backend.satkartar.org/assets/center/${path}`;
}
export const BASEMISURLS = (path) => {
    return `https://backend.satkartar.org/assets/mis/${path}`;
}
export const BASEAGENTURLS = (path) => {
    return `https://backend.satkartar.org/assets/agent/${path}`;
}